import { BrowserRouter } from 'react-router-dom';
import { WebinarSessions } from 'react-scale/components/WebinarSessions/WebinarSessions';
import { Flex, Button, Icon, Link, Callout } from '@scale/scaleui-radix';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { GenAIOpsHubPaths } from 'react-scale/corp/views/CorpProjectGroupManager/constants';
interface WebinarSessionsPageProps {}

export const WebinarSessionsPage: React.FC<WebinarSessionsPageProps> = () => {
  return (
    <div className="h-[calc(100vh-80px)] w-full">
      <WebinarHubBanner />
      <BrowserRouter basename="corp/expert-management/webinar">
        <WebinarSessions />
      </BrowserRouter>
    </div>
  );
};

const WebinarHubBanner = () => {
  return (
    <Flex direction="column" gap="4" p="4">
      <Callout.Root size="2" color="info">
        <Callout.Text size="3" weight="bold">
          Webinars have moved to the{' '}
          <Link href={`/corp${GenAIOpsHubPaths.Webinars}`} color="blue">
            Webinar Hub
          </Link>
          !
        </Callout.Text>
        <Callout.Text size="2">
          Webinar Hub allows you to create Webinars without needing a specific Project ID, so you
          can use it for all your Webinar needs. Soon, Webinars will no longer be accessible through
          Team Lead Dashboard.
        </Callout.Text>
        <Button size="2" variant="ghost" className="justify-start">
          Go to Webinar Hub <Icon icon={faArrowRight} label="Bookmark" />
        </Button>
      </Callout.Root>
    </Flex>
  );
};
